import { Burger, Group } from '@mantine/core';
import React from 'react';

import FoodaLogo from './FoodaLogo';
import PrivateLayoutUser from './PrivateLayout.user';
import PrivateLayoutMenu from './PrivateLayout.menu';

type PrivateLayoutHeaderProps = {
  opened: boolean;
  toggle: () => void;
};

const PrivateLayoutHeader: React.FC<PrivateLayoutHeaderProps> = ({ opened, toggle }) => {
  return (
    <Group h="100%" wrap="nowrap">
      <Group>
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        <FoodaLogo />
      </Group>
      <PrivateLayoutMenu />
      <PrivateLayoutUser />
    </Group>
  );
};

export default PrivateLayoutHeader;
